import {ErrorResponse, MasterDataResponse} from '@gp/shared/sdconnect/sdconnect-ext.model';

export interface SdcEventLogContext {
  zoneNames: string[];
  groupZoneName: string;
  beginDate: string;
  endDate: string;
}

export interface PersonPayrollLogDTO {
  contractId: string;
  sdcLogId: string;
  sdcLogMessage: string;
  creationDate: string;
  updateDate: string;
  entity: string;
  parentKey: string;
  key: string;
  values: any;
  status: 'IN_PROGRESS' | 'SUCCESS' | 'FAILED' | 'DELETED' | 'ARCHIVED';
  isLatest: boolean;
  latest: boolean;
}

/*Generated*/

export interface PersonDTO {
  data?: Record<string, PersonDataDTO[]>;
  metadata?: PersonModelMetadataDTO[];
  sdcLogs?: SdcLogDTO[];
}
export interface PayrollInputDataDTO extends PersonDataDTO {
  isDeletion?: boolean;
}

export interface PayrollInputDTO extends Omit<PersonDTO, 'data'> {
  data?: Record<string, PayrollInputDataDTO[]>;
}

export interface PersonDataDTO {
  /** @format date-time */
  key?: string;
  parentKey?: string;
  creationDate?: string;
  status?: 'IN_PROGRESS' | 'SUCCESS' | 'FAILED' | 'DELETED';
  /** @format date-time */
  updateDate?: string;
  values?: object;
  sdcLogId?: number;

  [key: string]: any;
}

export interface PersonModelMetadataDTO {
  fields?: string[];
  name?: string;
}

export interface SdcLogDTO {
  context?: string;
  /** @format int64 */
  contractId?: number;
  correlationId?: string;
  /** @format date-time */
  creationDate?: string;
  /** @format date */
  employeeBeginDate?: string;
  /** @format date */
  employeeEndDate?: string;
  /** @format int64 */
  employeeId?: number;
  employeeOtherId1?: string;
  eventId?: string;
  eventType?:
    | 'NEW_HIRE'
    | 'RE_HIRE'
    | 'NEW_CONTRACT'
    | 'TERMINATE_EMPLOYMENT'
    | 'PROVISIONING'
    | 'UPDATE_ADDRESSES'
    | 'UPDATE_PERSON_HISTORIES'
    | 'UPDATE_BANK_ACCOUNTS'
    | 'UPDATE_FAMILY_MEMBERS_HISTORIES'
    | 'UPDATE_CONTRACTS'
    | 'UPDATE_ORGANIZATIONS'
    | 'UPDATE_SALARIES'
    | 'UPDATE_WORK_SCHEDULES'
    | 'UPDATE_LEDGERS'
    | 'UPDATE_FACILITIES'
    | 'UPDATE_COMPANY_CARS'
    | 'NEW_FAMILY_MEMBERS'
    | 'UPDATE_CHANGE_MARITAL_STATUS'
    | 'NIFI_PROCESS'
    | 'GET_PEOPLE_CALL'
    | 'GET_STATUS'
    | 'SDC3'
    | 'SDC3_PAYROLL_INPUT';
  httpRespBody?: string;
  httpRespCode?: string;
  /** @format int64 */
  id?: number;
  jsonSent?: string;
  message?: string;
  payGroup?: string;
  status?: 'IN_PROGRESS' | 'PENDING' | 'SUCCESS' | 'FAILED';
  /** @format date-time */
  updateDate?: string;
}

export interface SdcStatusDTO {
  alerts?: string[];
  errors?: string[];
  personMasterDataSyncEnabled?: boolean;
  personMasterDataSyncOnSDC2Activated?: boolean;
  personMasterDataSyncOnSDC3Activated?: boolean;
  payrollInputSyncActivated?: boolean;
}

export enum SdcLogStatuses {
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS'
}

export enum PersonPayrollLogStatuses {
  IN_PROGRESS = 'IN_PROGRESS',
  FAILED = 'FAILED',
  SUCCESS = 'SUCCESS',
  DELETED = 'DELETED',
  ARCHIVED = 'ARCHIVED'
}

export enum SdcEventTypes {
  SDC3 = 'SDC3',
  SDC3_PAYROLL_INPUT = 'SDC3_PAYROLL_INPUT',
  NEW_HIRE = 'NEW_HIRE',
  RE_HIRE = 'RE_HIRE',
  NEW_CONTRACT = 'NEW_CONTRACT',
  TERMINATE_EMPLOYMENT = 'TERMINATE_EMPLOYMENT',
  PROVISIONING = 'PROVISIONING',
  UPDATE_ADDRESSES = 'UPDATE_ADDRESSES',
  UPDATE_PERSON_HISTORIES = 'UPDATE_PERSON_HISTORIES',
  UPDATE_BANK_ACCOUNTS = 'UPDATE_BANK_ACCOUNTS',
  UPDATE_FAMILY_MEMBERS_HISTORIES = 'UPDATE_FAMILY_MEMBERS_HISTORIES',
  UPDATE_CONTRACTS = 'UPDATE_CONTRACTS',
  UPDATE_ORGANIZATIONS = 'UPDATE_ORGANIZATIONS',
  UPDATE_SALARIES = 'UPDATE_SALARIES',
  UPDATE_WORK_SCHEDULES = 'UPDATE_WORK_SCHEDULES',
  UPDATE_LEDGERS = 'UPDATE_LEDGERS',
  UPDATE_FACILITIES = 'UPDATE_FACILITIES',
  UPDATE_COMPANY_CARS = 'UPDATE_COMPANY_CARS',
  NEW_FAMILY_MEMBERS = 'NEW_FAMILY_MEMBERS',
  UPDATE_CHANGE_MARITAL_STATUS = 'UPDATE_CHANGE_MARITAL_STATUS',
  NIFI_PROCESS = 'NIFI_PROCESS',
  GET_PEOPLE_CALL = 'GET_PEOPLE_CALL',
  GET_STATUS = 'GET_STATUS'
}

export interface PersonSdcResponse {
  status: number;
  masterDataResponse?: MasterDataResponse;
  errorResponse?: ErrorResponse;
}

export enum SDC3ConfigModes {
  DEFAULT = 'DEFAULT',
  PARTIAL = 'PARTIAL'
}

export interface SDC3Config {
  mode?: SDC3ConfigModes;
  partials?: Record<string, boolean>;
}

export enum SdcEntities {
  Address = 'Address',
  BankAccount = 'BankAccount',
  PersonHistory = 'PersonHistory',
  FamilyMember = 'FamilyMember',
  FamilyMemberHistory = 'FamilyMemberHistory',
  Employment = 'Employment',
  Contract = 'Contract',
  Organization = 'Organization',
  WorkSchedule = 'WorkSchedule',
  CompanyCar = 'CompanyCar',
  Salary = 'Salary',
  Ledger = 'Ledger',
  Facility = 'Facility'
}
